var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quickstart',[(_vm.$route.params.action === 'overview')?_c('orgaOverview'):(_vm.$route.params.action === 'switch')?_c('orgaSwitch'):(_vm.$route.params.action === 'new')?_c('orgaNew'):(_vm.$route.params.action === 'list')?_c('orgaList'):_c('orgaEdit')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }